<template>
  <div v-bind:class="{ bodyDisabled: spinnerVisible }">
    <pulse-loader :loading="spinnerVisible" color="#187da0"></pulse-loader>
    <router-view></router-view>
  </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import Vue from 'vue'
    import Toasted from 'vue-toasted'
    import { eventHub } from './utils/eventhub'
    import moment from 'moment';
    import Vuelidate from 'vuelidate'
    import * as AppStorage from "./storage/appstorage";

    Vue.use(Vuelidate)

    Vue.use(Toasted, {
        duration : 1200,
        position: 'top-center',
        theme: 'toasted-primary'
    });

export default {
  name: 'app',
    components: { PulseLoader },
    data: function () {
        return {
            role: 'user',
            spinnerVisible: false
        }
    },
    methods: {
        showSpinner() {
            this.spinnerVisible = true;
        },
        hideSpinner() {
            this.spinnerVisible = false;
        }
    },
    created() {
        eventHub.$on('before-request', this.showSpinner);
        eventHub.$on('request-error',  this.hideSpinner);
        eventHub.$on('after-response', this.hideSpinner);
        eventHub.$on('response-error', this.hideSpinner);
    },
    beforeDestroy() {
        eventHub.$off('before-request', this.showSpinner);
        eventHub.$off('request-error',  this.hideSpinner);
        eventHub.$off('after-response', this.hideSpinner);
        eventHub.$off('response-error', this.hideSpinner);
    }
}
    Vue.filter('formatDate', function(value, format) {
      format = format || 'DD.MM.YYYY в HH:mm'
        if (value) {
            return moment(String(value)).format(format)
        }
    });
</script>

<style lang="scss">

  body {
    width:100%;
    height:100%;
  }

  .bodyDisabled {
    position:relative;
    overflow:hidden;
    width: 100%;
    height: 100%;
  }

  .bodyDisabled:before {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
    cursor: wait;
    z-index: 200;
  }
  .v-spinner {
    position: absolute;
    top: 49%;
    left: 50%;
    margin-left: -28px;
    z-index: 1000;

  }
  .container {
    padding: 0;
    width:100%;
    height:100%;
  }
  .pulse-enter-active {
    animation: bounce-in .5s;
  }
  .pulse-leave-active {
    animation: bounce-in .5s reverse;
  }

  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';

  .dashed {
    border-bottom: 1px dashed #eee;
    margin-bottom: 20px;
  }
</style>
